const pregnancyStatus = {
  0: "Drachtig",
  1: "Schijndrachtig",
  2: "Gust",
  3: "Onbekend",
};

export default pregnancyStatus;
